import { configureStore } from "@reduxjs/toolkit";
import activePage from "./reducers/active_page";
import category from "./reducers/category";
import dashboardData from "./reducers/dashboard";
import products from "./reducers/product";
import transactions from "./reducers/report";
import toast from "./reducers/toast_message";
import user from "./reducers/user";
import referral from "./reducers/referral";

export const store = configureStore({
  reducer: {
    activePage,
    category,
    dashboardData,
    products,
    transactions,
    toast,
    user,
    referral,
  },
});
